import React from 'react';
import { useState } from 'react';
import LoaderTri from '../../components/Loader/LoaderTri';
import { Image } from 'antd';
// import sushilContactImage from '../../assets/images/w.jpg';
import { variableName } from '../../variableName';
import Header from '../../Header';
import Footer from '../../Footer';
import msme from './msme_966048256.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';


const textWidth = 90;

const ContactUs = () => {

    const [isLoading, setIsLoading] = useState(true);




    const [form, setForm] = useState({
        fullName: "",
        phone: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const sendMail = () => {

                const fullName = "John";
                const email = "cristoworkmail@gmail.com";
                const message = "Hello";

                window.location.href =
                    `mailto:cristoferrao2@gmail.com?subject=Contact Enquiry&body=
     Name:${fullName}%0D%0A
     Email:${email}%0D%0A
     Message:${message}`;
            };

            sendMail();

            // await fetch("http://localhost:5000/api/contact", {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json"
            //     },
            //     body: JSON.stringify(form)
            // });

            alert("Enquiry sent successfully!");

        } catch (error) {

            console.error("Error sending enquiry:", error);
            alert("Failed to send enquiry. Please try again later.");
        }

    };




    return (
        <>
            <Header />

            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-7 text-center '>
                        <br />
                        {isLoading && <LoaderTri />}
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.7566805885435!2d74.45378980000001!3d16.689055099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0e3ede554b2b3%3A0x27624485a1640d8f!2sProsushil%20Lifecare%20LLP!5e0!3m2!1sen!2sin!4v1770184103715!5m2!1sen!2sin"
                            width="90%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="eager"
                            referrerPolicy="no-referrer-when-downgrade"
                            onLoad={() => {
                                console.log("onLoad");
                                setIsLoading(false);
                            }}
                            title='Google Map'
                        ></iframe>
                        <br />


                        <div className='' style={{
                            paddingLeft: 70,
                            paddingRight: 70,

                        }}>
                            {/* <h4 className='text-start '>PHONE NO</h4> */}
                            <br />
                            {/* <div className='text-start'><u style={{ fontWeight: 500 }}>Phone No</u> : 08351-  271888. 271332. 273432</div> */}
                            {/* <div className='text-start'><u style={{ fontWeight: 500 }}>Mobile No</u>: 9423275276</div> */}
                            <div className='text-start'><u style={{ fontWeight: 500, width: textWidth, display: "inline-block" }}>Office</u> : 8975431601 / 027559166589</div>
                            <div className='text-start'><u style={{ fontWeight: 500, width: textWidth, display: "inline-block" }}>Email</u> : prosushillifecarellp@gmail.com</div>
                            <div className='text-start'><u style={{ fontWeight: 500, width: textWidth, display: "inline-block" }}>Accounts</u> : 7559176589</div>
                            <div className='text-start'><u style={{ fontWeight: 500, width: textWidth, display: "inline-block" }}>Dispatch</u> : 7507156589</div>

                        </div>



                    </div>
                    <div className='col-md-5'>
                        <br />


                        <div className=' ' style={{ width: "90%" }}>
                            <h4>{variableName.outerHeaderName}</h4>

                            <h6 >

                                Upper Basement Floor, C.S.No. 632/9A/640/638/638/35C<br />
                                M.No.172000629, 17/438/3/1, Meena Mall, Near Panchavati Talkies,<br />
                                ICHALKARANJI - 416 115. Tal Hatkanangale, Dist. Kolhapur.<br />
                            </h6>
                            <br />








                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />
            <br />

            <Footer></Footer>

        </>
    )
}

export default ContactUs